import { StowageInstructionsApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'

class StowageInstructionService {
  httpClient = createApiClient(StowageInstructionsApi)

  async get() {
    const { data } = await this.httpClient.get()
    return data
  }
}

export const stowageInstructionService = new StowageInstructionService()
